module.exports = __webpack_public_path__ + "img/wariness.9663e813.svg";